// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewChild, ViewRef, ElementRef, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// NGRX
// Service
//Models
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { DatePipe } from '@angular/common';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';


@Component({
	selector: 'kt-in-doi-tra-hang',
	templateUrl: './in-doi-tra-hang.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})


export class DoiTraHangPrintComponent implements OnInit {

	@Input() masterData: any;
	@Input() detailData: any[];
	constructor(
		private datePipe: DatePipe) {};
		
	/**
	 * On init
	 */
	departments: string[] = ['QA', 'Kho', 'RD', 'KD B2B', 'KD B2C', 'Marketing', 'Mua hàng', 'Cơ điện', 'BP. Kế toán', 
	'HCNS', 'CNTT', 'Kế hoạch', 'BP. SX- Khu TP rau củ', 'BP.SX- Khu Chế biến', 'BP.SX- Khu TT', 'BP.SX- Khu xay', 'BP.SX- Khu HBL', 'BP.cân PL', 'BP'];
	lyDos: string[] = ['Hàng sau SX', 'Hàng dư nhập trả lại kho', 'Hàng trả về từ khách hàng'];

	ngOnInit() {
		console.log(this.masterData)
	}
	
	get_date_nhap_kho(){
		
		 var date = new Date(this.masterData.NgayTao);
		 return ("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
		return "         ";
	}
	FormatDatetime(datetime) {
		return this.datePipe.transform(datetime, 'dd/MM/yyyy');
	}
	sum_so_luong(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.SoLuongDoi)).reduce((a, b) => a + b) : 0;
	}
	sum_thanh_tien(){
		// ;
		return this.detailData.length > 0 ? this.detailData.map(x => Number(x.ThanhTien)).reduce((a, b) => a + b) : 0;
	}
	checkBoPhan(item: string){
		return this.masterData.TenBoPhanDeNghi.trim().toLowerCase() === item.trim().toLowerCase();
	}
	checkLyDo(item: string){
		return this.masterData.LyDo.trim().toLowerCase() === item.trim().toLowerCase();
	}
	getLyDo(){
		if(this.masterData.LyDo){
			return this.masterData.LyDo;
		}
		else if(this.detailData.find(x => x.IdDnCtCk != null)){
			const filteredList = this.detailData.filter(x => x.IdDnCtCk !== null);
			// Extract the SoPhieuDeNghi from the filtered list
			const SoPhieuDeNghiList = filteredList.map(x => x.SoPhieuDeNghi);
			return "Theo đề nghị chuyển kho số "+ SoPhieuDeNghiList;
		}
	}
	get_date(){
		var date = new Date();
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ "/"+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + "/"+ date.getFullYear(); 
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	ChungTuKemTheo(item){
		if(item){
			return this.masterData.ChungTuKemTheo?'none':''
		}
		return this.masterData.ChungTuKemTheo?'':'none'
	}
}
